@if (isLoading()) {
  <app-bimbo-spinner [fullscreen]="true" size="lg" />
} @else {
  <router-outlet />
}
